import React from "react";
import {withStyles, Table, TableCell, TableRow, TableBody} from "@material-ui/core";
import styles from "./styles";
import {
  getTotalDeliveryStops,
  getTotalCompletedDeliveryStops,
  completedVsTotalStopsFormatter,
  getEquipmentSuffix,
} from "../../utils/utils";
import { getDriverGateInAndOutTime } from "./utils";
import { formatDateTimeWithoutUTCConversion } from '@dataGrid/gridUtilities';
import Dropdown from "../../../../common/Dropdown";
import { getLatestBreaks } from "../utils";

const getFormattedValue = (value) => {
  return value || value === 0? value: "";
}

const RenderRowHeader = ({ labelList, classes }) => (
  <TableRow className={classes.tableRow}>
    {labelList.map((label) => (
      <TableCell className={classes.tableHeaderCell}>{label}</TableCell>
    ))}
  </TableRow>
);

const RenderSelectComponent = ({
  options,
  onChange,
  classes,
  selectedValue=null,
  readOnlyText = '',
  equipmentScac = null,
  showTrailerScac = false
}) => {
  if (options.length <= 1) {
    return (
      <span>
        {equipmentScac
          ? `${readOnlyText} ${getEquipmentSuffix({
              equipmentScac,
              showTrailerScac
            })}`
          : readOnlyText}
      </span>
    );
  }

  return (
    <div className={classes.driverListDropdown}>
      <Dropdown
        placeholder="select"
        value={selectedValue}
        options={options}
        onChange={onChange}
        customReactSelectClass={classes.reactSelect}
        usePortal
      />
    </div> 
  );
};

const Details = withStyles(styles)(function ({
  classes,
  routeData,
  currentDriverRoutes,
  changeRouteData,
  showTrailerScac,
  enableRestBreakInDelay
}) {
  const getDropdownOptions = (key) => {
    let labelSuffix = "";
    return currentDriverRoutes.map((route) => {
      if (showTrailerScac && key === "trailerNumber") {
        labelSuffix = getEquipmentSuffix({
          equipmentScac: route.trailerScac,
          showTrailerScac,
        });
      }
      return {
        value: route.routeId,
        label: `${route[key]} ${labelSuffix}`,
      };
    });
  };

  const totalDeliveryStops = getTotalDeliveryStops(routeData.stops);
  const currentDriverRouteNames = getDropdownOptions("routeName");
  const currentDriverManifests = getDropdownOptions("manifestNumber");
  const currentDriverTrailers = getDropdownOptions("trailerNumber");
  const totalCompletedDeliveryStops = getTotalCompletedDeliveryStops(
    routeData.stops
  );

  
  const {latestLunchBreak, latestFuelBreak, latestRestBreak} = getLatestBreaks(routeData.delays)
  const {gateInTime, gateOutTime} = getDriverGateInAndOutTime({
    gateInTime: routeData.gateInTime,
    gateOutTime: routeData.gateOutTime
  });
  return (
    <Table size="small" className={classes.routeDetails}>
      <TableBody>
        <RenderRowHeader 
          classes = {classes}
          labelList = {["Trip #", "Dispatch Time", "Route"]}
        />
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.enrouteTo}>
            {routeData.tripNumber}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {formatDateTimeWithoutUTCConversion({ value: routeData.driverDispatchTime })}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            <RenderSelectComponent
              options={currentDriverRouteNames}
              selectedValue = {routeData.routeId}
              classes={classes}
              onChange={changeRouteData}
              readOnlyText = {routeData.routeName}
            />
          </TableCell>
        </TableRow>
        <RenderRowHeader 
          classes = {classes}
          labelList = {["Manifest #", "Gate Out - In", "Stops"]}
        />
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableDataCell}>
            <RenderSelectComponent
              options={currentDriverManifests}
              selectedValue = {routeData.routeId}
              classes={classes}
              onChange={changeRouteData}
              readOnlyText = {routeData.manifestNumber}
            />
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {`${gateOutTime} - ${gateInTime}`}
          </TableCell>

          <TableCell className={classes.tableDataCell}>
            {completedVsTotalStopsFormatter(routeData)}
          </TableCell>
        </TableRow>
        <RenderRowHeader 
          classes = {classes}
          labelList = {["Trailer #", "Lunch Start - End", "Deliveries"]}
        />
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableDataCell}>
            <RenderSelectComponent
              options={currentDriverTrailers}
              selectedValue = {routeData.routeId}
              classes={classes}
              onChange={changeRouteData}
              readOnlyText = {routeData.trailerNumber}
              equipmentScac = {routeData.trailerScac}
              showTrailerScac={showTrailerScac}
            />
          </TableCell>
          <TableCell className={classes.tableDataCell}>
          {latestLunchBreak
              ? `${getFormattedValue(latestLunchBreak.startTime)} - ${getFormattedValue(latestLunchBreak.endTime)}`
              : ""}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {`${totalCompletedDeliveryStops}/${totalDeliveryStops}`}
          </TableCell>
        </TableRow>
        <RenderRowHeader 
          classes = {classes}
          labelList = {["Tractor #", "Fuel In - Out", "Pickups"]}
        />
        <TableRow className={classes.tableRow}>
          <TableCell className={classes.tableDataCell}>
            {routeData.tractorNumber}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {latestFuelBreak ? `${getFormattedValue(latestFuelBreak.startTime)} - ${getFormattedValue(latestFuelBreak.endTime)}` : ''}
          </TableCell>
          <TableCell className={classes.tableDataCell}>
            {`${routeData.completedPickups || 0}/${
              routeData.totalPickups || 0
            }`}
          </TableCell>
        </TableRow>
        {enableRestBreakInDelay ? (
          <>
            <RenderRowHeader classes={classes} labelList={['Rest Start - End']} />
            <TableRow className={classes.tableRow}>
              <TableCell className={classes.tableDataCell}>
                {latestRestBreak
                  ? `${getFormattedValue(latestRestBreak.startTime)} - ${getFormattedValue(
                      latestRestBreak.endTime
                    )}`
                  : ''}
              </TableCell>
            </TableRow>
          </>
        ) : null}
      </TableBody>
    </Table>
  );
});

export default Details;
